import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import ButtonWithIcon from './ButtonWithIcon'
import PostTitle from './Item/PostTitle'
import ImageCarousel from './ImageCarousel'
import OwnWant from './OwnWant'
import Kudos from './Kudos'
import styles from './ItemFull.icss'

class ItemFull extends React.Component {
	constructor(props) {
		super(props)
		this.state = { drawerOpen: false }
		this.handleDrawerClose = this.handleDrawerClose.bind(this)
		this.handleToggle = this.handleToggle.bind(this)
	}

	handleToggle() {
		this.setState(prevState => ({ drawerOpen: !prevState.drawerOpen }))
	}

	handleDrawerClose() {
		this.setState({ drawerOpen: false })
	}

	render() {
		const { classes, isLoading, itemFragment, renderAfterItem, iconName, imageContent, imageClassName, title, fitScoreTesting, description, onContextClick, subtitle, counts, showOwnWant, showCountComments, countComments, countCommentsClick, shareClick, showKudos, kudos, kudosCount, kudosSet, own, want, ownSet, wantSet, ...otherProps } = this.props
		const { showFollow, follow, followSet, ...anchorProps } = otherProps
		anchorProps.href = (otherProps.onClick && !otherProps.href ? 'javascript:void()' : otherProps.href) || '#' // eslint-disable-line no-script-url
		return (
			<div className={classNames(styles.item, classes.root, { [styles.isLoading]: isLoading })}>
				{itemFragment || (
					<>
						<PostTitle
							iconName={iconName}
							href={anchorProps.href}
							onClick={anchorProps.onClick}
							onContextClick={onContextClick}
							subtitle={subtitle}
							counts={counts}
							title={title}
						/>

						<section className={styles.image}>
							<Link className={styles.link} to={anchorProps.href} {...anchorProps}>
								{imageContent && (
									<ImageCarousel images={imageContent} />
								)}
							</Link>
						</section>

						{showOwnWant && (
							<section className={styles.ownWantContainer}>
								<OwnWant
									own={own}
									want={want}
									ownSet={ownSet}
									wantSet={wantSet}
									showFits
									//	TODO: remove title, as it is only used for fake KF score
									title={fitScoreTesting}
								/>
							</section>
						)}
						{(showKudos) && (
							<section className={styles.statsContainer}>
								{showKudos && (
									<section className={styles.kudosContainer}>
										<Kudos
											kudos={kudos}
											kudosSet={kudosSet}
											kudosCount={kudosCount}
										/>
									</section>
								)}
								{showCountComments && (
									<section className={styles.commentsCountContainer}>
										<ButtonWithIcon iconName="blackComments" onClick={countCommentsClick}>
											<span>{this.context.translate('{countComments|# comment|# comments}', { countComments: (countComments || 0) })}</span>
										</ButtonWithIcon>
									</section>
								)}
								<section className={styles.shareContainer}>
									<ButtonWithIcon iconName="blackShare" onClick={shareClick}>
										<span>{this.context.translate('Share')}</span>
									</ButtonWithIcon>
								</section>
							</section>
						)}
					</>
				)}
				{renderAfterItem && renderAfterItem}
			</div>
		)
	}
}

ItemFull.contextTypes = {
	translate: PropTypes.func
}

ItemFull.propTypes = {
	classes: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	description: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]), // eslint-disable-line react/forbid-prop-types
	imageContent: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.string),
		PropTypes.shape({ type: PropTypes.string, webpurl: PropTypes.string, url: PropTypes.string }),
		PropTypes.arrayOf(PropTypes.shape({ type: PropTypes.string, webpurl: PropTypes.string, url: PropTypes.string })),
		PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({ type: PropTypes.string, webpurl: PropTypes.string, url: PropTypes.string })))
	]),
	imageClassName: PropTypes.string,
	isLoading: PropTypes.bool,
	itemFragment: PropTypes.node,
	renderAfterItem: PropTypes.node,
	itemType: PropTypes.string,
	iconName: PropTypes.string,
	onContextClick: PropTypes.func,
	subtitle: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.string), PropTypes.string]), // eslint-disable-line react/forbid-prop-types
	counts: PropTypes.oneOfType([PropTypes.func, PropTypes.array]), // eslint-disable-line react/forbid-prop-types
	title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
	fitScoreTesting: PropTypes.string,	//	Note: only used for the fit for score
	showOwnWant: PropTypes.bool,
	showCountComments: PropTypes.bool,
	countComments: PropTypes.number,
	countCommentsClick: PropTypes.func,
	shareClick: PropTypes.func,
	showKudos: PropTypes.bool,
	kudos: PropTypes.bool,
	kudosSet: PropTypes.func,
	kudosCount: PropTypes.number,
	own: PropTypes.bool,
	want: PropTypes.bool,
	ownSet: PropTypes.func,
	wantSet: PropTypes.func
}

ItemFull.defaultProps = {
	classes: {},
	description: [],
	imageContent: [{ url: '/images/placeholder.png' }],
	imageClassName: undefined,
	isLoading: false,
	itemFragment: undefined,
	renderAfterItem: undefined,
	itemType: 'product',
	iconName: undefined,
	onContextClick: undefined,
	subtitle: undefined,
	counts: undefined,
	title: undefined,
	fitScoreTesting: undefined,
	showOwnWant: false,
	showCountComments: false,
	countComments: undefined,
	countCommentsClick: () => {},
	shareClick: () => {},
	showKudos: false,
	kudosCount: undefined,
	kudos: undefined,
	kudosSet: undefined,
	own: false,
	want: false,
	ownSet: undefined,
	wantSet: undefined
}

export default ItemFull



// WEBPACK FOOTER //
// ./src/components/ItemFull.jsx